module.exports = __webpack_public_path__ + "static/senior-6-bcf5e917c5fb29fc65c7b9e0b4203147.jpg";